import Schema from './Schema'
import FieldDatetimeRange from '../fields/FieldDatetimeRange'
export default class SchemaDatetimeRange extends Schema {
  constructor(label, key, rules, options, on) {
    options.inTable = false
    options.asTabFilter = false
    options.asFilter = true
    options.editable = false
    options.sortable = false
    options.render = () => null
    super(options)
    FieldDatetimeRange.call(this, label, key, rules, on, rules)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaDatetimeRange.js